import { ThemeSchemaResponse } from '@api/api/theme-overview';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './MacroFinancialAboutSection.module.scss';

export const MacroFinancialAboutSection = ({
  theme,
  className,
  isCompact = false,
}: {
  theme: ThemeSchemaResponse;
  className?: string;
  isCompact?: boolean;
}) => {
  const { t } = useTranslation(['widget', 'common']);

  const themeDirections = {
    Contextual: t(
      'widget:themeOverview.tabs.overview.aboutThemeSection.themeDirectionContextual'
    ),
    Neutral: t('common:neutral'),
    IntuitivePositive: t(
      'widget:themeOverview.tabs.overview.aboutThemeSection.themeDirectionIntuitivePositive'
    ),
    IntuitiveNegative: t(
      'widget:themeOverview.tabs.overview.aboutThemeSection.themeDirectionIntuitiveNegative'
    ),
  };

  const themeDirectionDescriptions = {
    Contextual: t(
      'widget:themeOverview.tabs.overview.aboutThemeSection.themeDirectionDescriptionContextual'
    ),
    Neutral: t(
      'widget:themeOverview.tabs.overview.aboutThemeSection.themeDirectionDescriptionNeutral'
    ),
    IntuitivePositive: t(
      'widget:themeOverview.tabs.overview.aboutThemeSection.themeDirectionDescriptionIntuitivePositive'
    ),
    IntuitiveNegative: t(
      'widget:themeOverview.tabs.overview.aboutThemeSection.themeDirectionDescriptionIntuitiveNegative'
    ),
  };

  const directionType = theme.metadata?.direction_type;
  const intuitiveDirection = theme.metadata?.intuitive_direction;

  const directionKey =
    directionType === 'Intuitive'
      ? intuitiveDirection && (`Intuitive${intuitiveDirection}` as const)
      : directionType;

  return (
    <section
      className={clsx(styles.aboutWrapper, className, {
        [styles.compact]: isCompact,
      })}
      data-testid="macro-financial-about-section"
    >
      {!isCompact && (
        <>
          <div className={styles.title}>
            {t('widget:themeOverview.tabs.overview.aboutThemeSection.title')}
          </div>
          <div className={styles.description}>{theme.description}</div>
        </>
      )}
      {directionKey && (
        <div>
          <div className={styles.themeDirectionTitle}>
            {themeDirections[directionKey]}
          </div>
          <p className={styles.directionDescription}>
            {themeDirectionDescriptions[directionKey]}
          </p>
        </div>
      )}
    </section>
  );
};
